export const uploadForm = () => {
    return {
        name: null,
        file: null
    }
}